module.exports = __webpack_public_path__ + "img/set_icon.342509d4.svg";